import { render, staticRenderFns } from "./MonthlyYearOverYearSales.vue?vue&type=template&id=ab28a670&scoped=true&"
import script from "./MonthlyYearOverYearSales.vue?vue&type=script&lang=js&"
export * from "./MonthlyYearOverYearSales.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyYearOverYearSales.vue?vue&type=style&index=0&id=ab28a670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab28a670",
  null
  
)

export default component.exports